import React from 'react';
import * as css from 'styles'
import { connect } from 'react-redux';
import styled from 'react-emotion'

import View from 'components/View/View';
import Link from 'components/Link/Link';
import FadeIn from 'components/Animated/FadeIn';
import withKeys from 'components/withKeys'
import Screen from 'components/Modal/Screen'
import Modal from 'components/Modal/Modal'

const NavLink = styled(Link)({
  fontSize: '1.25em', 
  letterSpacing: '0.05em',
  textTransform: 'uppercase', 

  '&:hover, &:focus': {
    textDecoration: 'underline',
  },
  // '&.active':{
  //   textDecoration: 'underline',
  // },
  [css.breakpoint.m_down]: {
    fontSize: '1em',
  },
})

// const NavOverlay = styled('div')({
//   position: 'fixed',
//   top: 0,
//   left: 0,
//   right: 0,
//   bottom: 0,
//   background: 'rgba(255,255,255,0.9)',
//   zIndex: css.z.modal,
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
// })

class NavPopup extends React.Component {

  renderLink = (item, i) => (
    <FadeIn key={item.url} right delay={`${i * 75}ms`}>
      <NavLink nav to={item.url} onClick={() => this.props.closeModal('filters')}>
        <View style={{ padding: `${css.space.xs} 0` }}>
          {item.title}
        </View>
      </NavLink>
    </FadeIn>
  )
  
  render() {
    const cats = this.props.cats && this.props.cats
      .filter(item => item.id!==1)
      .map(item => ({
        title: item.name, 
        url: item.slug === 'highlights' ? '/' : `/category/${item.slug}`, 
        order: item.acf.order || 50,
      }))

    const links = [
      { title: 'All Projects', url: '/category/all-projects', order: 2, },
      // { title: 'Motion', url: '/projects?cat=motion' },
      // { title: 'Stills', url: '/projects?cat=stills' },
      // { title: 'By Date', url: '/projects?sort=date' }, 
      ...cats, 
      { title: 'About', url: '/about', order: 100, }
    ].sort((a, b) => { return a.order - b.order })

    return (
      <Modal name="filters">

        <View style={{
          // maxWidth: '1000px',
          textAlign: 'center',
          fontSize: css.font.l,
        }}>
          {links.map((item, i)=>this.renderLink(item, i))}
        </View>

      </Modal>
    )
  }
}

const mapState = state => ({
  data: state.projects.data,
  cats: state.categories.data,
  status: state.projects.status,
  error: state.projects.error,
  query: state.projects.query,
})

const mapDispatch = dispatch => ({
  closeModal: (name) => dispatch.modals.close({ name }),
})

export default withKeys(connect(mapState, mapDispatch)(NavPopup));



// WEBPACK FOOTER //
// ./src/containers/NavPopup.js